import { vuexPto } from '@/store/compositionV2/module/pto'
import { PTOSupplyApi } from '@/api/pto'
import { getYesOrNo } from '@/utils/string/getYesOrNo'
import { getUserFullName } from '@/utils/user'
import { mapJobItem } from '@/utils/page/pto/project/pto/map'

const state = () => ({
  ...vuexPto.createState(),
  api: PTOSupplyApi,
  namePageDetailed: 'PtoProjectPtoSupplyUpdate',
  expand: 'project,mol,requests,jobs',
  tableHeaders: [
    {
      title: '№ заявки',
      isSortable: true,
      sortName: 'request_number'
    },
    {
      title: 'Дата заявки',
      isSortable: true,
      sortName: 'request_date'
    },
    {
      title: 'Срок поставки',
      isSortable: true,
      sortName: 'delivery_date'
    },
    {
      title: 'Согласование тех. директора',
      isSortable: true,
      sortName: 'agreement'
    },
    {
      title: 'МОЛ',
      isSortable: true,
      sortName: 'mol.surname'
    },
    {
      title: 'Заявки',
      isSortable: false,
      sortName: ''
    }
  ]
})

const getters = {
  ...vuexPto.createGetters(),
  getList: state => {
    return state.list.map(item => {
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.request_number || '-',
          item.request_date || '-',
          item.delivery_date || '-',
          getYesOrNo(item.agreement) || '-',
          getUserFullName(item.mol) || '-',
          { data: item.requests?.length, mod: 'orders-count' }
        ]
      }
    })
  },
  getCurrentItem: state => ({
    ...state.currentItem,
    jobs: state.currentItem.jobs?.length ? state.currentItem.jobs.map(mapJobItem) : []
  })
}

const mutations = {
  ...vuexPto.createMutations()
}

const actions = {
  ...vuexPto.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
